const PHONE_MAX_WIDTH = 767;

export const scrollElementIntoViewOnMobile = (element: HTMLElement | null): void => {
  if (!element || window.innerWidth > PHONE_MAX_WIDTH) {
    return;
  }

  const scroll = (): void => {
    element.scrollIntoView({ block: 'center', inline: 'nearest' });
  };

  scroll();
  requestAnimationFrame(scroll);
  window.setTimeout(scroll, 300);
};
